import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/ContractBasis/LaneGroup/Lane/LaneOps.requests'
import {
    Lane,
} from '../Lanes/lanes.types'

const useGetLaneById = (id: number) => {
    return useRequest<Lane>({
        key: RequestKeys.getLaneOpsInformationById,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.laneOpsInformation),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetLaneById
